export async function setClipboard(url) {
	await navigator.clipboard.writeText(url);
}